<ion-note
	[ngClass]="{
		'error-class':
			form.get(dynamicFormControl.key).invalid &&
			(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
		'disabled-class': dynamicFormControl.disabled
	}"
	(click)="!dynamicFormControl.disabled && openModal()"
	>{{ displayDate | date: getDateFormat(dynamicFormControl.type) }}</ion-note
>
<ion-icon [class]="getIconClass()"></ion-icon>
